import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { InputField } from '../../../components/FormCommons'
import { InputAdornment } from '@mui/material'
import { ProductUtils } from 'wakacje-web-legacy/src/utils/ProductUtils'

export const CampFeesBase = ({ control, currency }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className='mb-2 mt-6 font-bold'>
        {t('ui.trips.base_price', 'Cena bazowa')}
      </div>
      <div className='mt-1 text-sm font-light'>
        {t(
          'ui.trips.base_price_description',
          'Cena nie będzie możliwa do późniejszej edycji. Będzie zawsze widoczna dla klienta.'
        )}
      </div>

      <div className='flex flex-col md:flex-row gap-2'>
          <Controller
              name="full_price"
              control={control}
              render={({ field, fieldState: { error } }) => {
                  const handleValueChange = event => {
                      const inputValue = parseFloat(event.target.value)

                      if (!isNaN(inputValue)) {
                          field.onChange(inputValue * 100)
                      } else {
                          field.onChange(null)
                      }

                      field.onBlur()
                  }

                  return (
                      <InputField
                          type="number"
                          label={t("ui.trips.price_per_person", "Cena / 1 osobę")}
                          // value={field.value ? field.value / 100 : ""}
                          value={field.value != null ? field.value / 100 : ""}
                          onChange={handleValueChange}
                          InputProps={{
                              endAdornment: (
                                  <InputAdornment position="end">
                                      {ProductUtils.getCurrencyCode(currency)}
                                  </InputAdornment>
                              )
                          }}
                      />
                  )
              }}
          />
          <Controller
              name={'payment_due_date'}
              control={control}
              render={({ field: { onChange, value }, fieldState: { error } }) => {
                  const val = value ? value.substr(0, 10) : ""
                  return (
                      <InputField
                          type='date'
                          onChange={onChange}
                          value={val}
                          InputLabelProps={{ shrink: true }}
                          label={t('ui.trips.payment_date_required', 'Termin płatności*')}
                          name={'payment_due_date'}
                      />
                  )
              }}
          />
      </div>
    </>
  )
}
